import { List, Record } from 'immutable';

export class LessonType extends Record({ id: '' }) {}

export const MASTER = new LessonType({ id: 'Master' });
export const TEMPLATE = new LessonType({ id: 'Template' });
export const PUBLISHED = new LessonType({ id: 'Published' });

const LESSON_TYPES = List([
  MASTER,
  TEMPLATE,
  PUBLISHED,
]);

export default LESSON_TYPES;
